import { useAiWorkspaceSync } from '../hooks/useAiWorkspaceSync';

// Isolates the aiSelectionStore subscription (via useAiWorkspaceSync -> useAiWorkspaceSelectionSync)
// in its own empty component so per-selection-change re-renders stop here instead of propagating to the root App.
export function AiWorkspaceSyncHost(): null {
  useAiWorkspaceSync();
  return null;
}
